import { MutationOptions, useMutation } from "@apollo/client";

import { GqlSettingsFormTemplateQuestionUpdateInput } from "~/__generated__";

import { SettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestionDocument } from "../mutations.generated";

export default function useSettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestion(
    refetchQueries?: MutationOptions["refetchQueries"],
) {
    const [mutate, { loading, error }] = useMutation(
        SettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestionDocument,
        {
            refetchQueries,
        },
    );

    const updateFormTemplateQuestion = async (input: GqlSettingsFormTemplateQuestionUpdateInput) => {
        await mutate({
            variables: { input },
        });
    };

    return {
        updateFormTemplateQuestion,
        loading,
        error,
    };
}
